/**
 * Auth-related constants shared between frontend and backend.
 */
import { z } from 'zod';

/**
 * Cookie name for the current organization context.
 * The frontend sets this cookie when the user's organization is loaded.
 * The backend reads this cookie to validate org-level authentication.
 */
export const ORG_COOKIE_NAME = 'x-current-org-id';

/** Proof supplied with email signup, independently of the verification redirect. */
export const signupAuthorizationSchema = z
  .object({
    email: z.email(),
    signupToken: z.uuidv4().optional(),
    orgCreateToken: z.uuidv4().optional(),
  })
  .refine(
    ({ signupToken, orgCreateToken }) =>
      Boolean(signupToken) !== Boolean(orgCreateToken),
    { message: 'Exactly one onboarding token is required' }
  );

export type SignupAuthorizationInput = z.input<
  typeof signupAuthorizationSchema
>;
